import React from "react";

function MLMPlans() {
  return (
    <>
      <div
        className="process-style-three-area default-padding bg-dark text-light bg-cover"
        style={{
          backgroundImage:
            "url(https://validthemes.net/site-template/robok/assets/img/shape/banner-22.jpg)",
        }}
      >
        <div className="shape">
          <img
            src="https://validthemes.net/site-template/robok/assets/img/illustration/16.png"
            alt="Image Not Found"
          />
        </div>
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <div className="site-heading">
                <h4 className="sub-title">How it works</h4>
                <h2 className="title split-text-right split-text-in-right">
                  MLM Plans
                </h2>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="row">
            <div className="col-lg-11 offset-lg-2">
              <div className="process-style-five-items">
                <div className="process-style-three-item fade-up-anim">
                  <div className="icon">
                    <img
                      src="https://validthemes.net/site-template/robok/assets/img/icon/27.png"
                      alt="Image Not Found"
                    />
                  </div>
                  <h4>Binary MLM Plan </h4>
                </div>

                <div className="process-style-three-item fade-up-anim">
                  <div className="icon">
                    <img
                      src="https://validthemes.net/site-template/robok/assets/img/icon/28.png"
                      alt="Image Not Found"
                    />
                  </div>
                  <h4>Matrix MLM Plan </h4>
                </div>

                <div className="process-style-three-item fade-up-anim">
                  <div className="icon">
                    <img
                      src="https://validthemes.net/site-template/robok/assets/img/icon/29.png"
                      alt="Image Not Found"
                    />
                  </div>
                  <h4>Unilevel MLM Plan </h4>
                </div>

                <div className="process-style-three-item fade-up-anim">
                  <div className="icon">
                    <img
                      src="https://validthemes.net/site-template/robok/assets/img/icon/27.png"
                      alt="Image Not Found"
                    />
                  </div>
                  <h4>Stair Step MLM Plan </h4>
                </div>

                <div className="process-style-three-item fade-up-anim">
                  <div className="icon">
                    <img
                      src="https://validthemes.net/site-template/robok/assets/img/icon/28.png"
                      alt="Image Not Found"
                    />
                  </div>
                  <h4>Board MLM Plan </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container pt-5">
          <div className="row">
            <div className="col-lg-11 offset-lg-2">
              <div className="process-style-five-items">
                <div className="process-style-three-item fade-up-anim">
                  <div className="icon">
                    <img
                      src="https://validthemes.net/site-template/robok/assets/img/icon/28.png"
                      alt="Image Not Found"
                    />
                  </div>
                  <h4>Matrix MLM Plan </h4>
                </div>

                <div className="process-style-three-item fade-up-anim">
                  <div className="icon">
                    <img
                      src="https://validthemes.net/site-template/robok/assets/img/icon/28.png"
                      alt="Image Not Found"
                    />
                  </div>
                  <h4>Generation MLM Plan </h4>
                </div>

                <div className="process-style-three-item fade-up-anim">
                  <div className="icon">
                    <img
                      src="https://validthemes.net/site-template/robok/assets/img/icon/28.png"
                      alt="Image Not Found"
                    />
                  </div>
                  <h4>Level MLM Plan </h4>
                </div>

                <div className="process-style-three-item fade-up-anim">
                  <div className="icon">
                    <img
                      src="https://validthemes.net/site-template/robok/assets/img/icon/28.png"
                      alt="Image Not Found"
                    />
                  </div>
                  <h4>Linear MLM Plan </h4>
                </div>

                <div className="process-style-three-item fade-up-anim">
                  <div className="icon">
                    <img
                      src="https://validthemes.net/site-template/robok/assets/img/icon/28.png"
                      alt="Image Not Found"
                    />
                  </div>
                  <h4>Group MLM Plan </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default MLMPlans;
